
const URL_DICT = {
  sdg: (projectId, resourceId) => `projects/${projectId}/sdgs/${resourceId}`,
  impact: (projectId, resourceId) => `projects/${projectId}/impacts/${resourceId}`,
  project: (projectId) => `projects/${projectId}`,
};
// const URL_DICT = {
//   sdg: (projectId, resourceId) => `/projects/${projectId}/sdgs/${resourceId}`,
//   impact: (projectId, resourceId) => `/projects/${projectId}/impacts/${resourceId}`,
//   project: (projectId) => `/projects/${projectId}`,
// };
export class URLPatchSelector {
  static select({ type, id, id_resource }) {
    const builder = URL_DICT[type];

    if (!builder) {
      throw new Error(`No existe una url para el tipo: ${type}`);
    }

    return builder(id, id_resource); 
  }
}
